'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AutoComplete = require('material-ui/AutoComplete');

var _AutoComplete2 = _interopRequireDefault(_AutoComplete);

var _MenuItem = require('material-ui/MenuItem');

var _MenuItem2 = _interopRequireDefault(_MenuItem);

var _Chip = require('material-ui/Chip');

var _Chip2 = _interopRequireDefault(_Chip);

var _Avatar = require('material-ui/Avatar');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _TextFieldLabel = require('material-ui/TextField/TextFieldLabel');

var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getStyles = function getStyles(props, context, state) {
    var _context$muiTheme = context.muiTheme,
        baseTheme = _context$muiTheme.baseTheme,
        _context$muiTheme$tex = _context$muiTheme.textField,
        floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
        disabledTextColor = _context$muiTheme$tex.disabledTextColor,
        backgroundColor = _context$muiTheme$tex.backgroundColor;


    var styles = {
        root: {
            fontSize: 16,
            lineHeight: '24px',
            width: props.fullWidth ? '100%' : 256,
            height: props.floatingLabelText ? 72 : 48,
            display: 'inline-block',
            position: 'relative',
            backgroundColor: backgroundColor,
            fontFamily: baseTheme.fontFamily,
            cursor: props.disabled ? 'not-allowed' : 'auto'
        },
        floatingLabel: {
            color: props.disabled ? disabledTextColor : floatingLabelColor,
            pointerEvents: 'none',
            top: 38
        },
        floatingLabelFocusStyle: {
            transform: 'scale(0.75) translate(0, -36px)'
        }
    };
    return styles;
};

/**
 * @desc
 * [AutoComplete](http://www.material-ui.com/#/components/auto-complete) search for person.
 * Display selected as a [Chip](http://www.material-ui.com/#/components/chip).
 *
 * @example
 * <PersonPicker
 *     floatingLabelText="Contact"
 *     floatingLabelFiexed={true}
 *     value={{key: 'billyga@ntnu.no', text: 'Billy Gates', avatar: 'https://some.url/to/picture'}}
 *     onChange={this.handleChange}
 *     onSearch={this.handleSearch}
 * />
 */

var PersonPicker = function (_React$Component) {
    _inherits(PersonPicker, _React$Component);

    function PersonPicker() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PersonPicker);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PersonPicker.__proto__ || Object.getPrototypeOf(PersonPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            searchText: '',
            selected: _this.props.value && _this.props.value.text ? _this.props.value : null,
            dataSource: []
        }, _this.onChangeCallback = function (item) {
            if (_this.props.onChange) {
                if (item) {
                    _this.props.onChange({ key: item.key, text: item.text, avatar: item.avatar });
                } else {
                    _this.props.onChange(undefined);
                }
            }
        }, _this.handleNewRequest = function (search, index) {
            if (index !== -1) {
                _this.setState({
                    selected: search,
                    dataSource: [],
                    searchText: ''
                });
                _this.onChangeCallback(search);
            }
        }, _this.handleUpdateInput = function (text) {
            var state = { searchText: text };
            if (text.length > 2) {
                _this.props.onSearch(text).then(function (result) {
                    _this.setState({ dataSource: result.map(function (item) {
                            return {
                                key: item.key,
                                text: item.text,
                                avatar: item.avatar,
                                value: _react2.default.createElement(_MenuItem2.default, { key: item.key, value: item.key, primaryText: item.text, leftIcon: item.avatar && _react2.default.createElement(_Avatar2.default, { src: item.avatar }) })
                            };
                        }) });
                });
            } else {
                state.dataSource = [];
            }
            _this.setState(state);
        }, _this.handleDelete = function () {
            _this.setState({ selected: null });
            _this.onChangeCallback(undefined);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * @type {Object}
     * @property {boolean} fullWidth
     * @property {boolean} disabled
     * @property {Object} wrapStyle
     * @property {string} floatingLabelText
     * @property {boolean} floatingLabelFixed
     * @property {{key: string, text: string, avatar: ?string}} value Set a person
     * @property {function(selected: {key: string, text: string, avatar: ?string})} onChange Callback when a person is selected.
     * @property {function(searchText: string): Promise<Object[]>} onSearch List of {key: string, text: string, avatar: ?string} objects.
     */


    /**
     * @type {Object}
     */


    /**
     * @type {Object}
     */


    _createClass(PersonPicker, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var old = this.props.value && this.props.value.key;
            var next = nextProps.value && nextProps.value.key;
            if (old !== next) {
                this.setState({
                    selected: nextProps.value
                });
            }
        }

        /**
         * @type {function}
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */


        /**
         * @type {function}
         */

    }, {
        key: 'render',


        /**
         * @return {Node}
         */
        value: function render() {
            var _props = this.props,
                fullWidth = _props.fullWidth,
                wrapStyle = _props.wrapStyle,
                floatingLabelText = _props.floatingLabelText,
                floatingLabelFixed = _props.floatingLabelFixed,
                disabled = _props.disabled;


            var styles = getStyles(this.props, this.context, this.state);

            var chip = this.state.selected && _react2.default.createElement(
                'div',
                { style: Object.assign(styles.root, wrapStyle) },
                _react2.default.createElement(
                    _TextFieldLabel2.default,
                    {
                        muiTheme: this.context.muiTheme,
                        style: styles.floatingLabel,
                        shrinkStyle: styles.floatingLabelFocusStyle,
                        shrink: true,
                        disabled: disabled
                    },
                    floatingLabelText
                ),
                _react2.default.createElement(
                    _Chip2.default,
                    { disabled: disabled, onRequestDelete: this.handleDelete, style: { marginTop: 30 } },
                    this.state.selected.avatar && _react2.default.createElement(_Avatar2.default, { src: this.state.selected.avatar }),
                    this.state.selected.text
                )
            );

            var autocomplete = !this.state.selected && _react2.default.createElement(
                'div',
                { style: Object.assign({ width: fullWidth ? '100%' : 256, display: 'inline-block' }, wrapStyle) },
                _react2.default.createElement(_AutoComplete2.default, {
                    floatingLabelText: floatingLabelText,
                    floatingLabelFixed: floatingLabelFixed,
                    fullWidth: fullWidth,
                    searchText: this.state.searchText,
                    onUpdateInput: this.handleUpdateInput,
                    onNewRequest: this.handleNewRequest,
                    dataSource: this.state.dataSource,
                    filter: function filter() {
                        return true;
                    },
                    disabled: disabled
                })
            );

            return chip ? chip : autocomplete;
        }
    }]);

    return PersonPicker;
}(_react2.default.Component);

PersonPicker.propTypes = {
    fullWidth: _propTypes2.default.bool,
    disabled: _propTypes2.default.bool,
    wrapStyle: _propTypes2.default.object,
    floatingLabelText: _propTypes2.default.string.isRequired,
    floatingLabelFixed: _propTypes2.default.bool,
    value: _propTypes2.default.object,
    onChange: _propTypes2.default.func,
    onSearch: _propTypes2.default.func.isRequired
};
PersonPicker.contextTypes = {
    muiTheme: _propTypes2.default.object.isRequired
};
exports.default = PersonPicker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/material/PersonPicker.js
// module id = 694
// module chunks = 0